var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.53 18.47L15.689 14.629C16.973 13.106 17.75 11.143 17.75 9C17.75 4.175 13.825 0.25 9 0.25C4.175 0.25 0.25 4.175 0.25 9C0.25 13.825 4.175 17.75 9 17.75C11.143 17.75 13.106 16.973 14.629 15.689L18.47 19.53C18.616 19.676 18.808 19.75 19 19.75C19.192 19.75 19.384 19.677 19.53 19.53C19.823 19.238 19.823 18.763 19.53 18.47ZM1.75 9C1.75 5.002 5.002 1.75 9 1.75C12.998 1.75 16.25 5.002 16.25 9C16.25 12.998 12.998 16.25 9 16.25C5.002 16.25 1.75 12.998 1.75 9Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.1fbfcda2986639382b8fc89bad5378d2.svg";